import Vue from 'vue';
import Vuex from 'vuex';
// Helpers
import validatorEs from '@/helpers/validator/es';
// Types
import globalTypes from '@/store/types/global';
// Components Libraries
import { Validator } from 'vee-validate';

// Modules
// import reservationModule from '@/store/modules/reservations';
import whiteLabelModule from '@/store/modules/whiteLabel';
// import metricsModule from '@/store/modules/metrics';
// import searchsModule from '@/store/modules/searchs';
// import pollModule from '@/store/modules/poll';
// import authModule from '@/store/modules/auth';
import externalPrecompro from '@/store/modules/externalPrecompro';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    online: true,
    language: 'es',
    multiLanguage: 'spanish',
    url: '',
    vendorUrl: '',
    vendor: [],
    socket: false,
    vendorId: (process.browser && window.localStorage.getItem('_vendorId') ? window.localStorage.getItem('_vendorId') : []),
    isMobile: false,
    orientation: null,
    width: null,
    height: null,
    idVendor: 0,
    loadingGeneral: false,
    reservation: (process.browser && window.localStorage.getItem('_reservation') ? JSON.parse(atob(window.localStorage.getItem('_reservation'))) : {})
  },
  actions: {
    [globalTypes.actions.changeLanguage]: ({ commit }, lang) => {
      commit(globalTypes.mutations.setLanguage, lang);
      switch (lang) {
        case 'en':
          Validator.localize('en', validatorEs);
          break;
        case 'es':
          Validator.localize('es', validatorEs);
          break;
        default:
          Validator.localize('en', validatorEs);
      }
    },
    [globalTypes.actions.vendorId]: ({ commit }, vendor) => {
      return new Promise((resolve, reject) => {
        Vue.axios.get('vendorFromUrl?url=' + vendor.data.url)
          .then(response => {
            if (process.browser && response.data.code === 200) {
              window.localStorage.setItem('_vendorId', response.data.vendorId);
              window.localStorage.setItem('_id', response.data.vendorId);
            }
            commit(globalTypes.mutations.setVendorId);
            commit(globalTypes.mutations.setId);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [globalTypes.actions.vendor]: ({ commit }, vendor) => {
      return new Promise((resolve, reject) => {
        Vue.axios.get('vendors/' + vendor.data.vendorId)
          .then(response => {
            if (process.browser) {
              commit(globalTypes.mutations.setVendor, response.data.data);
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  getters: {
    [globalTypes.getters.loadingGeneral]: state => state.loadingGeneral,
    [globalTypes.getters.multiLanguage]: state => state.multiLanguage,
    [globalTypes.getters.language]: state => state.language,
    [globalTypes.getters.vendorUrl]: state => state.vendorUrl,
    [globalTypes.getters.vendorId]: state => state.vendorId,
    [globalTypes.getters.idVendor]: state => state.idVendor,
    [globalTypes.getters.socket]: state => state.socket,
    [globalTypes.getters.url]: state => state.url,
    [globalTypes.getters.vendor]: state => state.vendor,
    [globalTypes.getters.reservation]: state => state.reservation,
    [globalTypes.getters.online]: state => state.online,
    [globalTypes.getters.width]: state => state.width,
    [globalTypes.getters.height]: state => state.height
  },
  mutations: {
    [globalTypes.mutations.setLoadingGeneral] (state, loadingGeneral) {
      state.loadingGeneral = loadingGeneral;
    },
    [globalTypes.mutations.setUrl] (state, url) {
      state.url = url;
    },
    [globalTypes.mutations.setSocket] (state, socket) {
      state.socket = socket;
    },
    [globalTypes.mutations.setLanguage] (state, lang) {
      state.language = lang;
    },
    [globalTypes.mutations.setMultiLanguage] (state, lang) {
      state.multiLanguage = lang;
    },
    [globalTypes.mutations.setVendorUrl] (state, url) {
      state.vendorUrl = url;
    },
    [globalTypes.mutations.setVendorId] (state) {
      state.vendorId = (process.browser && window.localStorage.getItem('_vendorId')) ? window.localStorage.getItem('_vendorId') : [];
    },
    [globalTypes.mutations.setId] (state) {
      state.idVendor = (process.browser && window.localStorage.getItem('_id')) ? window.localStorage.getItem('_id') : [];
    },
    [globalTypes.mutations.setVendor] (state, vendor) {
      state.vendor = vendor;
    },
    [globalTypes.mutations.setOnline] (state, status) {
      state.online = status;
    },
    [globalTypes.mutations.setReservation] (state) {
      state.reservation = (process.browser && window.localStorage.getItem('_reservation')) ? JSON.parse(atob(window.localStorage.getItem('_reservation'))) : {};
    },
    [globalTypes.mutations.setWidth] (state, width) {
      state.width = width;
    },
    [globalTypes.mutations.setHeight] (state, height) {
      state.height = height;
    }
  },
  modules: {
    // authModule,
    // reservationModule,
    whiteLabelModule,
    // metricsModule,
    // searchsModule,
    // pollModule,
    externalPrecompro
  }
});
